var _circle, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconApprove = function SvgIconApprove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.624,
    cy: 66.958,
    r: 47.86,
    fill: "#EAEEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD4E2",
    d: "M93.133 40.884H67.638v-9.675h33.604c5.222.123 9.461 4.437 9.461 9.675H99.644"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Icon-Approve_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon-Approve_svg__b)",
    d: "M101.978 31.209c-1.965.123-3.808.924-5.099 2.28-.122.123-.245.246-.368.431-1.167 1.356-2.027 3.143-2.027 5.053v57.56c0 5.362-4.3 9.675-9.645 9.675H37.902V38.542c.123-1.972.86-3.76 2.15-5.053 1.414-1.418 3.318-2.28 5.468-2.28H101.978Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3BFD3",
    d: "M85.146 44.397H71.201a.946.946 0 0 1-.922-.925c0-.493.43-.924.922-.924h13.945c.492 0 .922.431.922.924a.906.906 0 0 1-.922.925ZM64.627 44.397H46.443a.946.946 0 0 1-.921-.925c0-.493.43-.924.921-.924h18.246c.491 0 .921.431.921.924 0 .493-.43.925-.983.925ZM76.3 53.517H58.175a.946.946 0 0 1-.921-.924c0-.493.43-.925.921-.925H76.3c.492 0 .922.432.922.925.061.493-.369.924-.922.924Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4DBEC",
    d: "M52.34 53.517h-5.897a.946.946 0 0 1-.921-.924c0-.493.43-.925.921-.925h5.898c.491 0 .921.432.921.925 0 .493-.43.924-.921.924ZM85.145 62.638H74.026a.946.946 0 0 1-.921-.924c0-.493.43-.924.921-.924h11.12c.49 0 .921.43.921.924a.906.906 0 0 1-.921.924Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3BFD3",
    d: "M68.682 62.638H46.443a.946.946 0 0 1-.921-.924c0-.493.43-.924.921-.924h22.239c.491 0 .921.43.921.924a.906.906 0 0 1-.921.924ZM76.3 71.759H64.073a.946.946 0 0 1-.922-.924c0-.493.43-.925.922-.925h12.225c.492 0 .922.431.922.925.061.493-.369.924-.922.924Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4DBEC",
    d: "M58.73 71.759H46.443a.946.946 0 0 1-.921-.924c0-.493.43-.925.921-.925h12.348c.492 0 .922.431.922.925 0 .493-.43.924-.983.924Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3BFD3",
    d: "M85.146 80.88h-8.539a.946.946 0 0 1-.921-.924c0-.493.43-.925.921-.925h8.54c.49 0 .92.432.92.925a.906.906 0 0 1-.92.924Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4DBEC",
    d: "M71.077 80.88H56.763a.946.946 0 0 1-.921-.924c0-.493.43-.925.921-.925h14.314c.492 0 .922.432.922.925 0 .493-.43.924-.922.924Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3BFD3",
    d: "M51.42 80.88h-4.977a.946.946 0 0 1-.921-.924c0-.493.43-.925.921-.925h4.976c.492 0 .922.432.922.925 0 .493-.43.924-.922.924ZM76.3 90h-8.478a.946.946 0 0 1-.922-.924c0-.493.43-.924.922-.924H76.3c.491 0 .921.431.921.924.062.493-.368.925-.921.925Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4DBEC",
    d: "M62.231 90H46.443a.946.946 0 0 1-.921-.924c0-.493.43-.924.921-.924h15.788c.492 0 .922.431.922.924 0 .493-.43.925-.922.925Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD4E2",
    d: "M64.197 98.567h12.41c0 2.095.86 4.006 2.211 5.361 1.352 1.418 3.256 2.219 5.345 2.219H28.32a7.557 7.557 0 0 1-5.345-2.219 7.603 7.603 0 0 1-2.211-5.361H57.5s6.819.062 6.696 0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.754 41.243c-.225.953-.562 1.96-.956 2.801-1.067 2.073-2.753 3.697-4.832 4.761-2.135 1.065-4.664 1.513-7.193.952-5.956-1.232-9.777-7.057-8.54-12.995 1.235-5.937 7.023-9.802 12.98-8.514 2.135.448 3.989 1.512 5.562 2.969 2.641 2.632 3.765 6.441 2.979 10.026Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon-Approve_svg__c)",
    fillRule: "evenodd",
    d: "M23 30.104a5 5 0 0 1 3.419-4.744l10-3.333a5 5 0 0 1 3.162 0l10 3.333A5 5 0 0 1 53 30.104V39c0 9.17-9.267 14.736-13.233 16.699a3.96 3.96 0 0 1-3.534 0C32.267 53.736 23 48.17 23 39v-8.896Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.442 33.903a.6.6 0 0 1 1.116 0l.43 1.085a.6.6 0 0 0 .796.33l1.072-.463a.6.6 0 0 1 .789.789l-.463 1.072a.6.6 0 0 0 .33.795l1.085.431a.6.6 0 0 1 0 1.116l-1.085.43a.6.6 0 0 0-.33.796l.463 1.072a.6.6 0 0 1-.789.789l-1.072-.463a.6.6 0 0 0-.795.33l-.431 1.085a.6.6 0 0 1-1.116 0l-.43-1.085a.6.6 0 0 0-.796-.33l-1.072.463a.6.6 0 0 1-.789-.789l.463-1.072a.6.6 0 0 0-.33-.795l-1.085-.431a.6.6 0 0 1 0-1.116l1.085-.43a.6.6 0 0 0 .33-.796l-.463-1.072a.6.6 0 0 1 .789-.789l1.072.463a.6.6 0 0 0 .795-.33l.431-1.085Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon-Approve_svg__d)",
    fillRule: "evenodd",
    d: "M95.636 70.115a3.115 3.115 0 1 0-6.231.017v19.714a1.039 1.039 0 0 1-2.077 0V74.27a3.115 3.115 0 1 0-6.23 0v25.962l-4.207-5.755c-1.246-1.921-3.678-2.565-5.46-1.465-1.775 1.126-2.216 3.581-.986 5.496 0 0 6.783 10.266 9.674 14.661C83.01 117.563 87.694 121 96.452 121c14.501 0 15.799-11.199 15.799-14.538V78.423a3.115 3.115 0 0 0-6.231 0v13.5a1.039 1.039 0 0 1-2.077 0V72.192a3.115 3.115 0 1 0-6.23 0v17.654a1.039 1.039 0 0 1-2.077 0v-19.73Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon-Approve_svg__b",
    x1: 69.92,
    x2: 69.92,
    y1: 29.474,
    y2: 107.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon-Approve_svg__c",
    x1: 23,
    x2: 53,
    y1: 38.943,
    y2: 38.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E34E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56C4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon-Approve_svg__d",
    x1: 91,
    x2: 91,
    y1: 70.115,
    y2: 121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BA3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BACC"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon-Approve_svg__a",
    width: 108.075,
    height: 119,
    x: 15.903,
    y: 20.209,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2878_513386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2878_513386",
    result: "shape"
  })))));
};
export default SvgIconApprove;